<template>
    <a-timeline-item :color="color">
        <p class="h6">{{ time }}</p>
        <div v-if="isFree && !isCont" style="display:flex; flex-direction: column">
            <h5>{{ $t('appointment-timeline.free-slot') }}</h5>
            <a-button 
                style="width: 150px;" 
                shape="round" 
                type="primary" 
                icon="check-circle" 
                size="small"
                @click="performApprove">
                {{ $t('appointment-actions.assign') }}
            </a-button>
        </div>
        <div v-if="!isFree && !isCont" style="margin-top: 10px; display:flex; flex-direction: column; align-items: start; justify-content: start;">
            <div style="display:flex; flex-direction: row; align-items: center; justify-content: start;">
                <a-avatar
                    slot="avatar"
                    :size="48"
                    shape="square"
                    :src="avatar"
                />
                <div style="margin-left: 10px; display:flex; flex-direction: column">
                    <p> {{ appointmentType }}</p>
                    <h6 style="margin-bottom: 2px"> {{ appointmentPerson }} </h6>
                    <p> {{ appointmentAddress }} </p>
                </div>
            </div>
            <div class="mb-20" style="display: flex; justify-content: space-between; align-items:center; margin-top: 10px;">
                <a-button
                    class="reschedule-button" 
                    style="width: 135px; margin-right: 10px;" 
                    shape="round" 
                    type="primary" 
                    size="small"
                    @click="performReschedule">
                    <a-icon type="history" :style="{ 'color': 'black' }" />
                    {{ $t('appointment-actions.reschedule') }}
                </a-button>
                <a-button 
                    class="cancel-button"
                    style="width: 125px;" 
                    shape="round" 
                    type="primary" 
                    icon="close-circle" 
                    size="small"
                    @click="performCancel">
                    {{ $t('appointment-actions.cancel') }}
                </a-button>
            </div>
        </div>

        <div v-if="isCont" style="margin-top: 10px; height: 92px; display:flex; flex-direction: row; align-items: start; justify-content: start;">
            <p>Continuing Previous Appointment</p>
        </div>
        <approve-modal 
            @success="(e) => $emit('approved', e)"
            @parentModal="(e) => $emit('parentModal', e)"
            :hour="item.hour" 
            :min="item.min" 
            :date="item.date" 
            ref="approveModal" 
        />
        <reschedule-modal
            @success="(e) => $emit('rescheduled', e)"
            :hour="item.hour" 
            :min="item.min" 
            :date="item.date" 
            ref="rescheduleModal" 
        />
        
    </a-timeline-item> 
</template>

<script>
import ApproveModal from '../review/modals/ApproveModal.vue';
import RescheduleModal from '../review/modals/RescheduleModal.vue';
import moment from 'moment';
export default {
  components: { ApproveModal, RescheduleModal },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        isFree() {
            if (this.item) {
                if (this.item.appointments.length == 0) {
                    return true;
                } else {
                    return false;
                }
            }
            return true; 
        },
        isCont() {
            return this.item ? this.item.cont: false;
        },
        color() {
            if (this.item.cont)
                return "gray";

            if (this.isFree)
                return "green";
            return "red";
        },
        avatar() {
            if (!this.isFree && 
                this.item && 
                this.item.appointments.length > 0 && 
                this.item.appointments[0].visitor && 
                this.item.appointments[0].visitor.imageUrl && 
                this.item.appointments[0].visitor.imageUrl.length > 0)
                return this.item.appointments[0].visitor.imageUrl;
            else
                return '/images/default-avatar.jpg';
        },
        appointmentType() {
            if (!this.isFree) {
                switch(this.item.appointments.length > 0 && this.item.appointments[0].type) {
                    case 'ONLINE':
                        return this.$t('appointment-types.online');
                    case 'IN_PERSON':
                        return this.$t('appointment-types.in-person');
                }
            }
            return '';
        },
        appointmentPerson() {
            if (!this.isFree) {
                if (this.item.appointments.length > 0 && this.item.appointments[0].visitor && this.item.appointments[0].visitor.fullName.length > 0) {
                    if (this.item.appointments[0].visitor && this.item.appointments[0].visitor.fullName.length > 23)
                        return this.item.appointments[0].visitor.fullName.substr(0, 21) + '...';
                    else
                        return this.item.appointments[0].visitor.fullName

                } else {
                    return '';
                }
            }
            return '';
        },
        appointmentCompany() {
            if (!this.isFree) {
                return this.item.appointments[0].visitor && this.item.appointments[0].visitor.company && this.item.appointments[0].visitor.company.length > 0 ? this.item.appointments[0].visitor.company.substr(0, 21) + '...' : '';
            }
            return '';
        },
        appointmentAddress() {
            if (!this.isFree ) {

                if (this.item.appointments[0].visitor && this.item.appointments[0].visitor.address != null){
                    if (this.item.appointments[0].visitor.address.length > 0) {
                        if (this.item.appointments[0].visitor.address && this.item.appointments[0].visitor.address.length > 23)
                            
                            return this.item.appointments[0].visitor.address.substr(0, 21) + '...';
                        else
                            return this.item.appointments[0].visitor.address;
                    }else{
                        return "";
                    }
                } else {
                    return '';
                }

                // return this.item.appointments[0].visitor && this.item.appointments[0].visitor.address && this.item.appointments[0].visitor.address.length > 0 ? this.item.appointments[0].visitor.address.substr(0, 21) + '...' : '';
            }
            return '';
        },
        time() {
            if (this.item) {
                let h = this.item.hour;
                let suffix = this.$t('time.am');
                if (h > 12) {
                    h -= 12;
                    suffix = this.$t('time.pm');
                }

                return this.$n(h).padStart(2, this.$n(0) + '') + ":" + this.$n(this.item.min).padStart(2, this.$n(0) + '') + ' ' + suffix;
                
            }
        }
    },
    methods: {
        performApprove() {
            this.$refs.approveModal.showModal();
        },
        performReschedule() {
            console.log(this.item.appointments[0]);
            this.$refs.rescheduleModal.showModal(this.item.appointments[0]);
        },
        performCancel() {
            this.$emit('cancel', this.item);
        }
    },
    
}
</script>